export default __webpack_public_path__ + "static/media/beefyfinance_night.0d13ab13.png";